import { showControlTypeName } from '@/utils/control_type'
import { Col, Row } from 'antd'
import './../Checkpoints.style.less'
import { isObjectLike } from 'lodash'

type Props = {
  data: any
  editComponent?: any
}

function ControlTypeSelectDropdown({ data, editComponent = null }: Props) {
  const renderEditCheckpoint = editComponent ? (
    <Col span={1}>{editComponent()}</Col>
  ) : (
    <></>
  )
  const displayData = () => {
    return data?.value && isObjectLike(data?.value) ? data.value?.label : ''
  }
  return (
    <Col span={24}>
      <div className="control-type-multi-select-container page-break-inside">
        <Col span={12}>
          <p className="label">{showControlTypeName(data)}</p>
        </Col>
        <Col span={11}>
          <Row>
            <p className="value">{displayData()}</p>
          </Row>
        </Col>
        {renderEditCheckpoint}
      </div>
    </Col>
  )
}

export default ControlTypeSelectDropdown
